import { useSurveyStore } from "../store/useSurveyStore";
import { useState, useRef, useEffect } from "react";
import { Button, TextField, Box, Typography, Paper } from "@mui/material";
import mixpanel from "@/utils/analytics";

export default function Compliance({ onContinue }) {
	const { complianceText, setComplianceInput, setComplianceTimestamp } = useSurveyStore();
	const [input, setInput] = useState("");
	const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
	const [isAgreementValid, setIsAgreementValid] = useState(false);
	const scrollContainerRef = useRef(null);

	// Check if user has scrolled to bottom
	const handleScroll = () => {
		const container = scrollContainerRef.current;
		if (container) {
			const { scrollTop, scrollHeight, clientHeight } = container;
			// Consider scrolled to bottom if within 10px of the bottom
			const isAtBottom = scrollHeight - scrollTop - clientHeight < 10;

			// Only update if we're setting it to true (once true, it stays true)
			if (isAtBottom) {
				mixpanel.track("read_compliance");
				setHasScrolledToBottom(true);
			}
		}
	};

	// Check if input matches "i agree" in any case or spacing variation
	useEffect(() => {
		const normalizedInput = input.trim().toLowerCase().replace(/\s+/g, "");
		const normalizedAgreement = "iagree";
		setIsAgreementValid(normalizedInput === normalizedAgreement);
	}, [input]);

	const handleSubmit = () => {
		if (isAgreementValid) {
			mixpanel.track("signed_compliance");
			setComplianceInput(input);

			const mysqlTimestamp = new Date().toISOString().slice(0, 19).replace("T", " ");
			setComplianceTimestamp(mysqlTimestamp);

			onContinue();
		}
	};

	return (
		<Box sx={{ maxWidth: "800px", margin: "0 auto", padding: "20px" }}>
			<Typography variant="h5" component="h1" gutterBottom>
				Compliance Agreement
			</Typography>

			<Paper
				ref={scrollContainerRef}
				onScroll={handleScroll}
				sx={{
					height: "60vh",
					overflow: "auto",
					padding: "20px",
					marginBottom: "20px",
					border: "1px solid #ccc",
					borderRadius: "4px",
				}}
			>
				<Typography variant="body1" component="div" sx={{ whiteSpace: "pre-line" }}>
					{complianceText}
				</Typography>
			</Paper>

			<Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
				<TextField
					label="Type 'I agree' to continue"
					variant="outlined"
					value={input}
					onChange={(e) => setInput(e.target.value)}
					disabled={!hasScrolledToBottom}
					helperText={!hasScrolledToBottom ? "Please scroll to the bottom of the agreement first" : ""}
					fullWidth
				/>

				<Button variant="contained" color="primary" onClick={handleSubmit} disabled={!hasScrolledToBottom || !isAgreementValid} size="large">
					Continue
				</Button>
			</Box>
		</Box>
	);
}
